import './reason.css';
import { IReasonComponentProps } from './interfaces/IReasonComponentProps';
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';

const Reason = ({heading, description}: IReasonComponentProps) => {
  const language: string = useSelector((state: RootState) => state.language.value);
  
  return <li className={`${language === "BG" ? 'lang-bg' : 'lang-en'}`}>
    <article>
      <h4>{heading}</h4>
      <p>{description}</p>
    </article>
  </li>
}

export default Reason
